module.exports = __webpack_public_path__ + "static/img/images_mPT.53c482b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/mobile/images_mPT.png
// module id = 9b3w
// module chunks = 0